export default __webpack_public_path__ + "static/media/au-qld.b0e2131a.svg";